import React, { useState } from "react";
import { DatePicker, List, Typography } from "antd";
import dayjs from "dayjs";
import "./PeriodCustomDatePicker.css";

import Calendar from "antd/es/calendar";

const { Text } = Typography;

export default function PeriodCustomDatePicker({
  firstStartDate,
  firstEndDate,
  secondStartDate,
  secondEndDate,
  setFirstStartDate,
  setFirstEndDate,
  onSelect,
  setShowDatePicker,
  onClose,
}) {
  const [firstRange, setFirstRange] = useState(
    firstStartDate && firstEndDate ? [firstStartDate, firstEndDate] : []
  );
  const [secondRange, setSecondRange] = useState(
    secondStartDate && secondEndDate ? [secondStartDate, secondEndDate] : []
  );

  const rangePresets = [
    { label: "Today", value: [dayjs(), dayjs()] },
    { label: "Yesterday", value: [dayjs().subtract(1, "day"), dayjs().subtract(1, "day")] },
    { label: "Last Week", value: [dayjs().subtract(1, "week"), dayjs()] },
    { label: "Last Month", value: [dayjs().subtract(1, "month"), dayjs()] },
    { label: "Last Quarter", value: [dayjs().subtract(3, "months"), dayjs()] },
    { label: "Reset All", value: null }
  ];

  const disableFuture = (current) => current && current > dayjs().endOf("day");

  const applyPreset = (presetValue) => {
    if (!presetValue) {
      setFirstRange([]);
      setSecondRange([]);
      return;
    }
    const [start, end] = presetValue;
    setFirstRange([start.format("YYYY-MM-DD"), end.format("YYYY-MM-DD")]);
  };

  const handleFirstSelect = (date) => {
    if (!firstRange.length || firstRange.length === 2) {
      setFirstRange([date.format("YYYY-MM-DD")]);
    } else {
      const [start] = firstRange;
      const end = date.format("YYYY-MM-DD");
      if (dayjs(start).isAfter(dayjs(end))) {
        setFirstRange([end, start]);
      } else {
        setFirstRange([start, end]);
      }
    }
  };

  const handleSecondSelect = (date) => {
    if (!secondRange.length || secondRange.length === 2) {
      setSecondRange([date.format("YYYY-MM-DD")]);
    } else {
      const [start] = secondRange;
      const end = date.format("YYYY-MM-DD");
      const finalSecondRange = dayjs(start).isAfter(dayjs(end)) ? [end, start] : [start, end];
      setSecondRange(finalSecondRange);

      setFirstStartDate(firstRange[0]);
      setFirstEndDate(firstRange[1]);

      onSelect({
        firstStart: firstRange[0],
        firstEnd: firstRange[1],
        secondStart: finalSecondRange[0],
        secondEnd: finalSecondRange[1],
      });

      setShowDatePicker(false);
      onClose();
    }
  };

  return (
    <div className="period-custom-picker">
      <div className="presets-sidebar">
        <List
          dataSource={rangePresets}
          renderItem={({ label, value }) => (
            <List.Item className="preset-item" onClick={() => applyPreset(value)}>
              {label}
            </List.Item>
          )}
        />
      </div>

      <div className="calendars-container">
        <div className="calendar-panel">
          <Text strong>First Range</Text>
          <Calendar
            fullscreen={false}
            disabledDate={disableFuture}
            onSelect={handleFirstSelect}
            dateFullCellRender={(date) => {
              const dateStr = date.format("YYYY-MM-DD");
              const isStart = dateStr === firstRange[0];
              const isEnd = dateStr === firstRange[1];
              const isInRange =
                firstRange.length === 2 &&
                dayjs(date).isBetween(firstRange[0], firstRange[1], null, "[]");
            
              let className = "ant-picker-cell-inner";
              if (isInRange) className += " first-ant-picker-cell-in-range";
              if (isStart) className += " first-range-start";
              if (isEnd) className += " first-range-end";
            
              return <div className={className}>{date.date()}</div>;
            }}
            
            headerRender={() => null} // Hides the year/month dropdown
          />
        </div>

        <div className="calendar-panel">
          <Text strong>Second Range</Text>
          <Calendar
            fullscreen={false}
            disabledDate={disableFuture}
            onSelect={handleSecondSelect}
            dateFullCellRender={(date) => {
              const dateStr = date.format("YYYY-MM-DD");
              const isStart = dateStr === secondRange[0];
              const isEnd = dateStr === secondRange[1];
              const isInRange =
                secondRange.length === 2 &&
                dayjs(date).isBetween(secondRange[0], secondRange[1], null, "[]");
            
              let className = "ant-picker-cell-inner";
              if (isInRange) className += " second-ant-picker-cell-in-range";
              if (isStart) className += " second-range-start";
              if (isEnd) className += " second-range-end";
            
              return <div className={className}>{date.date()}</div>;
            }}
            
            headerRender={() => null} // Hides the year/month dropdown
          />
        </div>
      </div>
    </div>
  );
}
